import Config from "../../../Configs";
import { ApiResponse, SavedItemsRequest, SavedItemsResponse, GetSavedItemByIdResponse, GetAllSavedItemsResponse } from "../../../Models";
import { SavedItemModel } from "../../../Models/ServerModels/SavedItems/SavedItem";
import { IHttpService } from "../IHttpService";
import { ApiServiceBase } from "./ApiServiceBase";

export default class SavedItemsApiService extends ApiServiceBase {
  constructor(client: IHttpService) {
    super(client);
  }

  async saveItem(data: SavedItemsRequest): Promise<ApiResponse<SavedItemsResponse>> {
    return await this._client.post<SavedItemsResponse>(Config.apiPaths.saveItem, data);
  }

  async getSavedItemById(itemId: number): Promise<ApiResponse<GetSavedItemByIdResponse>> {
    const id = itemId ? itemId : 0;
    return await this._client.get<GetSavedItemByIdResponse>(Config.apiPaths.getSavedItemById.replace("{0}", id.toString()));
  }

  async getAllSavedItems(): Promise<ApiResponse<GetAllSavedItemsResponse>> {
    return await this._client.get<GetAllSavedItemsResponse>(Config.apiPaths.savedItems);
  }

  async deleteSavedItemById(itemId: number): Promise<ApiResponse<string>> {
    return await this._client.post(Config.apiPaths.deleteSavedItems.replace("{0}", itemId.toString()));
  }

  async duplicateSavedItemById(itemId: number): Promise<ApiResponse<string>> {
    return await this._client.post(Config.apiPaths.duplicateSavedItem.replace("{0}", itemId.toString()));
  }

  async updateFarmerPractice(itemId: number, payload: { N: number; P: number; K: number }): Promise<ApiResponse<SavedItemModel>> {
    return await this._client.post<SavedItemModel>(Config.apiPaths.updateFarmerPractice.replace("{0}", itemId.toString()), payload);
  }

  async renameSavedItemById(itemId: number, name: string): Promise<ApiResponse<string>> {
    return await this._client.post(Config.apiPaths.renameSavedItem, {
      SavedItemId: itemId.toString(),
      Name: name,
    });
  }
}
